
import { DOCUMENT } from '@angular/common';
import { CdkTextareaAutosize } from '@angular/cdk/text-field';
import { Component, ElementRef, EventEmitter, Input, NgZone, Output, ViewChild, Inject, OnInit, OnDestroy } from '@angular/core';
import { DoctorProfile } from '@cureskin/api-client-rn';
import { MatBottomSheet, MatBottomSheetRef } from '@angular/material/bottom-sheet';
import { ActivatedRoute, Router } from '@angular/router';
import { FilePickerComponent } from '@components/file-picker/file-picker.component';
import { ApiClientConstant, Table } from '@cureskin/api-client';
import { AppWebBridgeService } from '@services/app-web-bridge-service';
import { BroadcastService } from '@services/broadcast-service';
import { ChatProgressService } from '@services/chat-progress-service/chat-progress.service';
import { isPhotoQuestion } from '@services/chat-service/chat-message.utils';
import { CommonUtilityHelper } from '@services/common-utility-helper/common-utility-helper';
import { ConnectionService } from '@services/connection-service';
import { ConsultationSessionService } from '@services/consultation-session-service';
import { CrossSellRegimenService } from '@services/cross-sell-regimen-service/cross-sell-regimen.service';
import { CurrentComponentService } from '@services/current-component';
import { EventLoggerService } from '@services/event-logger-service';
import { ExperimentService } from '@services/experiment/experiment.service';
import { ChatSkipLastQuestionsExperiment } from '@services/experiment/experiment.service.types';
import { LocalStorageService } from '@services/local-storage-service';
import { NavigationService } from '@services/navigation-service';
import { RegimenExpiryService } from '@services/regimen-expiry-service/regimen-expiry.service';
import { RegimenService } from '@services/regimen-service/regimen.service';
import { SentryErrorHandler } from '@services/sentry-logger';
import { TimeService } from '@services/time-service';
import { VOICE_INPUT_STATE, VoiceInputService } from '@services/voice-input-service';
import { appendTranscript, scrollTextFieldToEnd } from '@services/voice-input-service/text-field.utils';
import { WindowRefService } from '@services/window-ref-service';
import { GetFeedbackSheetComponent } from '@shared/bottom-sheet-layouts/get-feedback-sheet/get-feedback-sheet.component';
import { MoreInsightsBottomsheetComponent } from '@shared/bottom-sheet-layouts/more-insights-bottomsheet/more-insights-bottomsheet.component';
import { NotificationPermissionSheetComponent } from
  '@shared/bottom-sheet-layouts/notification-permission-sheet/notification-permission-sheet.component';
import { InputType, SingleSelectorService } from '@shared/single-selector/single-selector.service';
import { Subscription } from 'rxjs/index';
import { take } from 'rxjs/operators';
import { v4 as uuid } from 'uuid';

import { AllocatedRegimen } from '../app-constant-types';
import { AppConfig } from '../app.config';
import { ChatMessageData } from './chat-message/rebranded-single-selector/rebranded-single-selector.types';

type BotReplyBackoffTimeType = {t1: number, t2: number};
const PROGRESS_CHECK_FACE_FINAL_OK = 'ProgressCheckFaceFinalOk';
const FOLLOW_UP_INTRO_QUESTION = 'followupIntroMessage';

@Component({
  selector: 'chatV2-view',
  templateUrl: './chatV2-view.html',
  standalone: false,
})
export class V2ChatComponent implements OnInit, OnDestroy {
  isTabActive: boolean;
  @ViewChild('messageContainer', { static: false }) messageContainer: ElementRef;
  @ViewChild('unreadMessageDivider', { static: false }) unreadMessageDivider: ElementRef;
  @ViewChild(FilePickerComponent, { static: false }) filePickerComponent: FilePickerComponent;
  chats: Array<any> = [];
  startTimeOfBotReply: any;
  @Input('hideNavBar') hideNavBar: boolean;
  @Input('disableChat') disableChat: boolean;
  user: any;
  currentUser: Table.User;
  imageModal: any = {};
  isNotificationPermissionEnabled: any;
  @Input('where') where: any;
  @Input('dataFunctionName') dataFunctionName: string = 'getAssistantMessage';
  @Input('title') title: string;
  selectedChatType: any;
  @Input('chatScrollErrorY') chatScrollErrorY: number = 0;
  @Input('chatUniqueObject') set setChatUniqueObject(chatUniqueObject: any) {
    if (this.selectedChatType && chatUniqueObject && this.selectedChatType.id !== chatUniqueObject.id) {
      this.selectedChatType = chatUniqueObject;
      this.window.nativeWindow.location.reload();
    } else {
      this.selectedChatType = chatUniqueObject;
    }
  }
  @Output('chatScrollPossible') chatScrollPossible: EventEmitter<void> = new EventEmitter();
  @Output('chatLoadingStatus') chatLoadingStatus: EventEmitter<boolean> = new EventEmitter();
  @Output('botReplyInProcessChange') botReplyInProcessChange: EventEmitter<boolean> = new EventEmitter();
  isInternalUser: boolean;
  chatPayload: { limit?: number, loading: { old: boolean, new: boolean }, noMoreData?: boolean, input?: string } = {
    limit: 100,
    loading: {
      old: false,
      new: false,
    },
    noMoreData: false,
    input: undefined,
  };
  ui: {
    enableScrollToTop?: boolean;
    enableScrollToBottom: boolean;
    botReplyInProcess: boolean,
    userResponseSaveInProcess: boolean,
    botReplyTimeSeries: BotReplyBackoffTimeType,
    chatScrollTop?: number,
    chatInputEnable?: boolean;
  };
  waitForBotReplyTimer: any;
  responseModes: any[];
  subscriptions: Array<Subscription> = [];
  allocatedDoctor: DoctorProfile;
  interval: any;
  timer: any = {};
  experiments: Array<any> = [];
  allowAnimation: boolean = false;
  latestMessage: any;
  isHelpfull: boolean;
  @ViewChild('assistantPage', { static: false }) assistantPage: ElementRef;
  months: Array<any> = [];
  lastVisitedTime: Date;
  multiImageData: string[] = [];
  scrollThrottle: any;
  showCallPopup: boolean;
  afterSaveFeedback: boolean;
  dataLoadedTwice: boolean;
  startTimer:number;
  callBackExperimentEnable: boolean = false;
  newHelpTreeExperiment: boolean = false;
  newSupportQuestionId: string;
  disableChatInput: boolean = false;
  photoType: string;

  isTicketClosedBeforeTwoDays: boolean = false;
  ticketClosedDaysChecked: boolean = false;
  inTransitUser: boolean = false;
  regimens: Array<AllocatedRegimen> = [];
  crossSellRegimenV2Experiment: any;
  showNewCrossSellDiscountMessage: boolean = false;
  crossSellDiscount: number;
  crossSellDeadline: Date;
  isNotIOSDevice: boolean;
  fromSelfCheckupBanner: boolean;
  followUp: any;
  followUpChatCompleted: boolean = false;
  unpaidUserDoctorCallExperiment: boolean = false;
  isPaidUser: boolean = false;
  botReplyTimeSeries: BotReplyBackoffTimeType = { t1: 1000, t2: 1000 };
  whatDoCureskinMembersSayQuestionId: string = 'whatDoCureSkinMembersSay';
  chatSkipLastQuestionsExperiment: ChatSkipLastQuestionsExperiment;
  userFirstName: string;
  rebrandedTextInputVal: string = '';
  private autoAnswerTriggered: boolean = false;
  /** Resolved once from VoiceInputService — experiment + native STT bridge + non-iOS. */
  voiceMicSupported: boolean = false;
  voiceTooltipDismissed: boolean = false;
  private legacyInputContainsVoice: boolean = false;
  private rebrandedInputContainsVoice: boolean = false;

  @ViewChild('legacyChatInput') private legacyChatInput?: ElementRef<HTMLInputElement>;
  @ViewChild('rebrandedChatTextarea', { read: CdkTextareaAutosize }) private rebrandedChatAutosize?: CdkTextareaAutosize;
  private rebrandedChatTextareaEl?: ElementRef<HTMLTextAreaElement>;

  @ViewChild('rebrandedChatTextarea') set rebrandedChatTextarea(el: ElementRef<HTMLTextAreaElement> | undefined) {
    this.rebrandedChatTextareaEl = el;
    if (el && this.selectedChatType?.className === Table.SupportTicket.className) {
      el.nativeElement.focus();
    }
  }

  constructor(
    private conn: ConnectionService,
    private router: Router,
    private broadcast: BroadcastService,
    public appConfig: AppConfig,
    private route: ActivatedRoute,
    private appBridge: AppWebBridgeService,
    private zone: NgZone,
    private window: WindowRefService,
    private eventLogger: EventLoggerService,
    private timeService: TimeService,
    private currentComponent: CurrentComponentService,
    private sentry: SentryErrorHandler,
    private broadcastService: BroadcastService,
    private singleSelectorService: SingleSelectorService,
    private chatProgressService: ChatProgressService,
    private commonUtilityHelper: CommonUtilityHelper,
    private bottomSheet: MatBottomSheet,
    private localStorageService: LocalStorageService,
    private navigationService: NavigationService,
    private readonly consultationSessionService: ConsultationSessionService,
    private readonly crossSellRegimenService: CrossSellRegimenService,
    private readonly regimenExpiryService: RegimenExpiryService,
    private readonly regimenService: RegimenService,
    private readonly experimentService: ExperimentService,
    public readonly voiceInputService: VoiceInputService,
    @Inject(DOCUMENT) private document: Document) {
    this.currentComponent.set(this);
  }

  async ngOnInit(): Promise<any> {
    this.updateChatLoading(true);
    this.startTimer = new Date().getTime();
    this.currentComponent.set(this);
    this.voiceInputService.reset();
    this.isInternalUser = this.conn.isInternalUser();
    this.currentUser = this.conn.getCurrentUser();
    this.user = this.conn.getActingUser();
    this.userFirstName = this.user?.get('PatientName')?.split(' ')[0];
    this.isPaidUser = this.user?.get('orderState') === this.appConfig.Shared.User.OrderState.DELIVERED;
    this.isNotIOSDevice = (await this.appBridge?.requestOSInformation()) !== 'iOS';
    this.voiceMicSupported = await this.voiceInputService.isMicAvailable();
    await this.fetchActiveExperiments();
    this.regimens = await this.conn.fetchRegimens(null, true);
    this.months = this.appConfig.Shared.Months.map((each: any): void => each.name);
    this.fromSelfCheckupBanner = this.route.snapshot.queryParamMap?.get('fromSelfCaptureBanner') === 'true';
    this.subscriptions.push(this.broadcast.on<string>('NEW_MESSAGE_RECEIVED')
      .subscribe((): void => this.zone.run((): void => {
        if (!this.chatPayload.loading.old) this.loadNewChat();
      })));
    await this.initialize();
    const { showBanner, discount, deadline }: {
      showBanner: boolean,
      discount: number,
      deadline: Date
    } = this.crossSellRegimenService.evaluateCrossSellProps(
      this.regimens, this.crossSellRegimenV2Experiment,
    );
    this.showNewCrossSellDiscountMessage = showBanner;
    this.crossSellDiscount = discount;
    this.crossSellDeadline = deadline;
    if (!this.user) {
      this.user = await this.conn.getActingUser();
      this.selectedChatType = await this.conn.findSupportTicketById(this.route.snapshot.params.id, { translate: true });
      this.where = { supportTicket: this.selectedChatType };
    }
    this.inTransitUser = this.user?.get('orderState') === this.appConfig.Shared.User.OrderState.PROCESSING;
    this.lastVisitedTime = this.selectedChatType.get('lastVisited');
    await this.loadOldChat();
    await this.armBotReplyPollerIfWaiting();
    await this.autoAnswerFollowUpIntroMessage();
    this.messageContainer.nativeElement.addEventListener('scroll', (event: any): void => this.scrollListener(event));
    /**
     * we log the last visited time of ticket in both ngOnInit and ngOnDestroy.
     * 1. In some case if ngOnDestroy doesn't update it (if ppl directly close app), we can atleast use ngOnInit time.
     * 2. ngOnDestroy takes delay to log it, meanwhile if user go back to home screen of support,
     *    there we need lastVisited time to determine new messages logic. So we can atleast use ngOnInit time for that moment.
     */
    if (!this.isInternalUser && this.selectedChatType?.className === 'SupportTicket') {
      this.conn.updateUserLastActiveDetails(this.selectedChatType.id);
    }
    if (this.hideNavBar) {
      // send with a delay of 1000 milliseconds so that page end event finish its notification.
      setTimeout((): void => {
        this.appBridge.notifyAssistantLoaded('consultationSession');
      }, 1000);
    }
    const time = new Date().getTime() - this.startTimer;
    this.checkTicketClosedDays();
    if (this.selectedChatType?.className === Table.ConsultationSession.className) {
      this.consultationSessionService.updateConsultationDetailsInLocalStorage(this.selectedChatType);
    }
    if (this.selectedChatType?.className === 'FollowUp') this.followUp = await this.conn.findRecentFollowUp();
    this.eventLogger.trackEvent('chat_screen_time', { timeInMillSec: time });
  }

  checkTicketClosedDays(): any {
    const rawCompletedAt = this.selectedChatType?.get('completedAt');
    const completedAt = rawCompletedAt instanceof Date ? rawCompletedAt : rawCompletedAt?.iso ? new Date(rawCompletedAt.iso) : null;
    const diffInCompletedAt = this.timeService.differenceInDays(new Date(), completedAt);
    this.eventLogger.trackEvent('difference_in_completed_at_date', { timeInDays: diffInCompletedAt });
    this.isTicketClosedBeforeTwoDays = !!completedAt && diffInCompletedAt >= 2;
    this.ticketClosedDaysChecked = true;
  }

  async fetchActiveExperiments(): Promise<void> {
    this.experiments = await this.conn.findUserActiveExperiments();
    this.experiments.forEach((exp: any): void => {
      if (exp.key === 'call_back_feature') {
        this.callBackExperimentEnable = true;
      }
      if (exp.key === 'new_help_tree') {
        this.newSupportQuestionId = exp.variant.questionId;
        this.newHelpTreeExperiment = true;
      }
      if (exp.key === 'cross_sell_regimen_v2') {
        this.crossSellRegimenV2Experiment = exp;
      }
      if (exp.key === 'unpaid_user_pending_call_banner') {
        this.unpaidUserDoctorCallExperiment = true;
      }
      if (exp.key === 'chat_response_time') {
        this.botReplyTimeSeries = exp.variant?.response_time;
      }
      if (exp.key === 'chat_skip_last_questions') {
        this.chatSkipLastQuestionsExperiment = exp;
      }
    });
  }

  get isVoiceListening(): boolean {
    return this.voiceInputService.state === VOICE_INPUT_STATE.LISTENING;
  }

  get isVoiceMicVisible(): boolean {
    if (!this.voiceMicSupported) return false;
    const chatClass = this.selectedChatType?.className;
    return chatClass === Table.ConsultationSession.className
      || chatClass === Table.FollowUp.className
      || chatClass === Table.SupportTicket.className;
  }

  /** The always-on free-text bar (support/help chat), as opposed to the per-question textarea. */
  private get legacyTextInputVisible(): boolean {
    return !!this.ui?.chatInputEnable && !this.ui?.botReplyInProcess;
  }

  get showVoiceTooltip(): boolean {
    if (!this.isVoiceMicVisible) return false;
    if (this.voiceTooltipDismissed) return false;
    if (!this.rebrandedTextInputVisible && !this.legacyTextInputVisible) return false;
    return !this.chatPayload.input && !this.rebrandedTextInputVal;
  }

  dismissVoiceTooltip(): void {
    if (!this.voiceTooltipDismissed) {
      this.voiceTooltipDismissed = true;
    }
  }

  onLegacyVoiceTranscript(text: string): void {
    if (!text) return;
    this.dismissVoiceTooltip();
    this.chatPayload.input = appendTranscript(this.chatPayload.input, text);
    this.legacyInputContainsVoice = true;
    // ngModel only writes the DOM value on the next tick — scroll once it is actually there.
    setTimeout((): void => scrollTextFieldToEnd(this.legacyChatInput?.nativeElement));
  }

  onRebrandedVoiceTranscript(text: string): void {
    if (!text) return;
    this.dismissVoiceTooltip();
    this.rebrandedTextInputVal = appendTranscript(this.rebrandedTextInputVal, text);
    this.rebrandedInputContainsVoice = true;
    setTimeout((): void => {
      // cdkTextareaAutosize re-measures only on a real `input` event, so a programmatic write
      // would leave the box at one row however long the transcript is.
      this.rebrandedChatAutosize?.resizeToFitContent(true);
      scrollTextFieldToEnd(this.rebrandedChatTextareaEl?.nativeElement);
    });
  }

  onVoiceStateChange(state: 'idle' | 'listening' | 'error'): void {
    if (state === 'listening') {
      this.dismissVoiceTooltip();
    }
  }

  private clearStaleInputIfNoTextStep(): void {
    if (typeof this.latestMessage?.get !== 'function') return;
    const inputs = this.latestMessage.get('Inputs') || [];
    const hasTextInput = inputs.some((i: any): boolean => i?.type === 'TEXT');
    if (hasTextInput) return;
    if (this.chatPayload.input) this.chatPayload.input = '';
    if (this.rebrandedTextInputVal) this.rebrandedTextInputVal = '';
    this.legacyInputContainsVoice = false;
    this.rebrandedInputContainsVoice = false;
  }

  initialize(): void {
    this.chatProgressService.reset();
    this.ui = {
      chatInputEnable: false,
      botReplyInProcess: false,
      userResponseSaveInProcess: false,
      enableScrollToBottom: false,
      botReplyTimeSeries: { ...this.botReplyTimeSeries},
    };
    this.responseModes = this.appConfig.Shared.Assistant.ResponseModes;
  }

  addToChats(top: boolean, chats: Array<any>, fromAssistantReply?: boolean): void {
    if (!chats.length) return;
    if (top) {
      chats.reverse();
      this.recordScrollPosition();
    }
    chats.sort((item1: any, item2: any): number => {
      const t1 = item1.get('createdAt') ? item1.get('createdAt')
        .getTime() : new Date().getTime();
      const t2 = item2.get('createdAt') ? item2.get('createdAt')
        .getTime() : new Date().getTime();
      if (t1 === t2) {
        return 0;
      }
      return t1 > t2 ? 1 : -1;
    });
    this.chatProgressService.setSelectedChatType(this.selectedChatType.className);
    this.chatProgressService.processChatBatch(chats, this.selectedChatType.get('PrivateMainConcernClass'));
    let prevImage;
    chats.forEach(async (chat_: any, index: number): Promise<void> => {
      const chat = chat_;
      if (chat.get('showAfterTime') && !this.conn.isInternalUser() && !this.window.isRenderedInIframe()) { // if message has to be shown after certain time

        this.regimenService.sendRegimenAllocatedEventForIOS(this.selectedChatType?.get('PrivateMainConcernClass'));

        const timeLeft = (new Date(chat.get('showAfterTime')).getTime() - new Date().getTime());
        if (this.selectedChatType?.className === Table.ConsultationSession.className) {
          this.consultationSessionService.clearLastBotQuestionId(this.selectedChatType.get('PrivateMainConcernClass'));
        }
        this.openActiveSessionRegimen();
        if (timeLeft > 0) setTimeout((): void => this.startRegimenPreparationTimer(timeLeft, chat), 0);
      }
      chat.displayDate = this.timeService.formatDisplayDate(chat.get('createdAt'), this.months, this.isInternalUser);
      if (this.isInternalUser) {
        if (chat.get('MessageInEnglish')) chat.set('Message', chat.get('MessageInEnglish'));
        if (chat.get('subMessageInEnglish')) chat.set('subMessage', chat.get('subMessageInEnglish'));
      }

      if (chat?.get('questionId') === PROGRESS_CHECK_FACE_FINAL_OK) {
        this.followUpChatCompleted = true;
        this.localStorageService.delete('sideFaceUploadSkipped');
      }

      /**
       * If any chats are found to be created by (Owner != USER) after the lastVisitedTime of ticket,
       * Then we set 'unreadMessageStart' with length of chats below it (which length of unread messages).
       * Then we delete 'lastVisitedTime'. All needed data is set, so we delete it and let forEach continue.
       *
       */
      if (this.lastVisitedTime && chat.get('createdAt') > this.lastVisitedTime) {
        if (index > 0 && chats[index - 1].get('Owner') !== this.appConfig.Shared.Assistant.Owner.USER) {
          chat.set('unreadMessageStart', chats
            .slice(index, chats.length)
            .filter((each: any): boolean => ![this.appConfig.Shared.Assistant.Mode.SMS_COPY].includes(each.get('Mode')))
            .length);
        }
        delete this.lastVisitedTime;
      }

      if (chat.get('Mode') === this.appConfig.Shared.Assistant.Mode.REQUEST_IMAGE_RESPONSE_BOTH_SIDE_FACE) {
        const imageTypeMapping = chat.get('imageTypeMapping');
        const tempUrlArray = chat.get('tempUrl')?.split(',');
        if (tempUrlArray.length > 1) {
          if (imageTypeMapping?.LEFT_SIDE_FACE && imageTypeMapping?.RIGHT_SIDE_FACE) {
            const leftPath  = this.commonUtilityHelper.getGcsPath(imageTypeMapping.LEFT_SIDE_FACE);
            const rightPath = this.commonUtilityHelper.getGcsPath(imageTypeMapping.RIGHT_SIDE_FACE);
            const leftSignedUrl  = tempUrlArray.find(signedUrl =>
              this.commonUtilityHelper.getGcsPath(signedUrl.split('?')[0]) === leftPath);
            const rightSignedUrl = tempUrlArray.find(signedUrl =>
              this.commonUtilityHelper.getGcsPath(signedUrl.split('?')[0]) === rightPath);
            chat.set('bothSideTempUrls', leftSignedUrl && rightSignedUrl ?
              [ leftSignedUrl, rightSignedUrl ] : [tempUrlArray[1], tempUrlArray[0]]);
            if (await this.commonUtilityHelper.checkImageDeleted(leftSignedUrl)) chat.set('leftSignedUrlDeleted', true)
            if (await this.commonUtilityHelper.checkImageDeleted(rightSignedUrl)) chat.set('rightSignedUrlDeleted', true)
          } else {
            chat.set('bothSideTempUrls', [ tempUrlArray[1], tempUrlArray[0] ]);
            prevImage = chat;
          }
        } else {
          chat.set('Mode', prevImage ? this.appConfig.Shared.Assistant.Mode.BLOCK : this.appConfig.Shared.Assistant.Mode.IMAGE_CLUBBED);
          prevImage = prevImage ?? chat;
        }
        const imgArr = prevImage.get('imageArray') ?? [];
        imgArr?.push(chat);
        prevImage.set('imageArray', imgArr);
        prevImage.displayDate = chat.displayDate;
      }

      if (chat.get('Mode') === this.appConfig.Shared.Assistant.Mode.REQUEST_IMAGE_RESPONSE) {
        if (prevImage) {
          chat.set('Mode', this.appConfig.Shared.Assistant.Mode.BLOCK);
        } else {
          prevImage = chat;
          prevImage.set('Mode', this.appConfig.Shared.Assistant.Mode.IMAGE_CLUBBED);
        }
        const imgArr = prevImage.get('imageArray') || [];
        imgArr?.push(chat);
        prevImage.set('imageArray', imgArr);
        prevImage.displayDate = chat.displayDate;
      } else if (![this.appConfig.Shared.Assistant.Mode.BLOCK, this.appConfig.Shared.Assistant.Mode.UNBLOCK].includes(chat.get('Mode'))) {
        prevImage = undefined;
      }
    });

    this.consultationSessionService.setChats(chats);
    if (this.selectedChatType?.className === Table.ConsultationSession.className) {
      const regimenClass = this.selectedChatType.get('PrivateMainConcernClass');
      const lastBotQuestionId = this.consultationSessionService.getBotChats().slice(-1)[0]?.get('questionId');
      if (regimenClass && lastBotQuestionId) {
        this.consultationSessionService.setLastBotQuestionId(regimenClass, lastBotQuestionId, this.selectedChatType.id);
      }
    }

    this.zone.run((): number => this.chats.push(...chats));
  }


  expandImages(chat: any): void {
    this.window.replaceHash('./#images', (): void => {
      this.multiImageData = [];
    });
    this.multiImageData = chat.get('imageArray');
  }

  openImageModal(chat:any): void {
    this.imageModal = {
      open: true,
      imageUrl: chat.get('Message'),
    };
  }

  closeImageModal(): void {
    this.imageModal = {
      open: false,
    };
  }

  handelDownload(): void {
    const imgSrc = this.imageModal.imageUrl; // Get the image source
    // Fetch the image as a blob
    fetch(imgSrc)
      .then((response:any): void => response.blob())
      .then((blob:any): void => {
        // Create a temporary anchor element
        const link = this.document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.download = 'image.jpeg'; // Set the desired file name
        // Simulate click on the link to trigger the download
        link.click();
        // Clean up - remove the Object URL after the download
        URL.revokeObjectURL(link.href);
      })
      .catch((error:any): void => {
        console.error('Error fetching the image:', error);
      });
  }

  handelShare(): void {
    this.broadcast.broadcast('SHARE', { type: 'IMAGE_ONLY', url: this.imageModal.imageUrl });
  }


  get showReportGettingReadyBanner(): boolean {
    return this.selectedChatType?.className === 'FollowUp'
      && this.getLatestMessage(true)?.get('questionId') === PROGRESS_CHECK_FACE_FINAL_OK;
  }

  isPersistCtaVisible(index: number): boolean {
    const chat = this.chats[index];
    if (!chat?.get('persistCtaAfterReply')) return false;
    for (let i = index + 1; i < this.chats.length; i++) {
      if (this.chats[i].get('Owner') === this.appConfig.Shared.Assistant.Owner.USER) return false;
    }
    return true;
  }

  getLatestMessage(skipSMSCopy: boolean = false): any {
    let index = this.chats.length - 1;
    while (index >= 0) {
      if (skipSMSCopy && this.chats[index].get('Mode') === this.appConfig.Shared.Assistant.Mode.SMS_COPY) {
        index -= 1;
      } else {
        break;
      }
    }
    return this.chats[index];
  }

  async loadNewChat(): Promise<any> {
    if (!this.user || this.chatPayload.loading.new) return;
    this.chatPayload.loading.new = true;
    const where: any = { ...this.where };
    const latestMessage = this.getLatestMessage();
    if (latestMessage) {
      where.createdAt = { $gt: latestMessage.get('createdAt') };
    }
    try {
      const data = await this.conn[this.dataFunctionName]({
        where,
        ascending: 'createdAt',
      });
      if (data?.length && data?.[0].get('questionId') === PROGRESS_CHECK_FACE_FINAL_OK) {
        const notificationExperiment = this.experiments.find((item:any):any => item.key === 'notification_permission_popup');
        if (notificationExperiment) {
          setTimeout((): void => this.openBottomSheet(), 2000);
        }
      }
      if (this.selectedChatType?.className === 'SupportTicket' && data?.length
        && data[0].get('Owner') === this.appConfig.Shared.Assistant.Owner.BOT
        && !data[0].get('Inputs')?.length) {
        this.selectedChatType = await this.conn.findSupportTicketById(this.route.snapshot.params.id, { translate: true });
      }
      if (data.length === 0
        && latestMessage
        && latestMessage.get('messageAttendedByBot')
        && latestMessage.get('Owner') === this.appConfig.Shared.Assistant.Owner.USER) {
        this.startBotReplyTimer(true);
        return;
      }
      if (data.length === 1 && data[0]?.get('questionId') === this.whatDoCureskinMembersSayQuestionId) {
        this.startBotReplyTimer(true);
        return;
      }
      this.cancelBotReplyWaitingTimer();
      await this.addToChats(false, data, true);
      this.processDataAfterFetch();
      this.chatPayload.loading.new = false;
      this.chatPayload.loading.old = false;
      this.updateChatLoading(false);
      this.scrollChatToBottom();
    } catch (err) {
      if (err instanceof Error) {
        this.sentry.handleError(err);
      }
      this.chatPayload.loading.new = false;
      this.cancelBotReplyWaitingTimer();
      this.showError(err.message || err.toString());
    }
  }

  openBottomSheet(): void {
    // call function to check permission status true or false
    // if true then perimssionn already given
    this.appBridge.requestNotificationStatus().then((status:boolean) => {
      this.isNotificationPermissionEnabled = status;
      if (!this.isNotificationPermissionEnabled) {
        this.bottomSheet.open(NotificationPermissionSheetComponent, {
          data: {
            content: 'followup-completed',
            callback: (): void => {
              this.openNativePermissionPopup();
            },
          },
        });
      }
    })
  }

  openNativePermissionPopup(): void {
    this.appBridge.requestNotificationPermission();
  }


  async loadOldChat(): Promise<any> {
    if (!this.user || this.chatPayload.loading.old) return;
    this.chatPayload.loading.old = true;
    const initialLoad: boolean = (this.chats.length === 0);
    const where: any = { ...this.where };
    if (this.chats.length) {
      where.createdAt = { $lt: this.chats[0].get('createdAt') };
    }
    try {
      const data = await this.conn[this.dataFunctionName]({
        where,
        descending: ['createdAt'],
        limit: this.chatPayload.limit,
        option: { context: { translate: true } },
      });
      if (!data.length) {
        this.chatPayload.loading.old = false;
        if (!this.dataLoadedTwice) {
          setTimeout((): void => { this.loadOldChat(); }, 1000);
          this.dataLoadedTwice = true;
        }
        return;
      }
      await this.addToChats(true, data);
      this.processDataAfterFetch(true, !initialLoad);
      if (initialLoad) {
        await this.autoAnswerFollowUpIntroMessage();
      }
      this.chatPayload.loading.old = false;
      this.updateChatLoading(false);
    } catch (err) {
      if (err instanceof Error) {
        this.sentry.handleError(err);
      }
      this.chatPayload.loading.old = false;
      this.showError(err.message || err.toString());
    }
  }

  isBotReplyDelayed(message: any): boolean {
    const latestMessage = message;
    if (latestMessage // if bot didn't reply for user message for more than 5 minutes, then open chat input.
      && latestMessage.get('Owner') === this.appConfig.Shared.Assistant.Owner.USER
      && latestMessage.get('messageAttendedByBot')) {
      const lastMessageTime: any = new Date(latestMessage.get('createdAt')).getTime();
      const minutes = (new Date().getTime() - lastMessageTime) / 1000 / 60;
      if (minutes >= 5) {
        this.cancelBotReplyWaitingTimer();
        this.ui.chatInputEnable = true;
        return true;
      }
    }
    return false;
  }

  enableChatInput(): boolean {
    const message = this.latestMessage;
    if (this.selectedChatType?.get('status') === this.appConfig.Shared.Ticket.status.Completed) {
      if (this.callBackExperimentEnable) {
        this.disableChatInput = false;
      }
      return false;
    }
    if (this.selectedChatType?.get('status') === this.appConfig.Shared.Ticket.status.Pending
        && this.selectedChatType?.get('treeCompleted') && this.callBackExperimentEnable
    ) {
      this.disableChatInput = true;
      return false;
    }
    if ((!message || message.get('blockInputAfterMessage') === false) && !this.selectedChatType.get('disableChat')) return true;
    if (this.isBotReplyDelayed(message)) return true;
    if (message?.get('blockInputAfterMessage')) return false;
    if ((message?.get('Inputs') && message.get('Inputs')?.length)) {
      return false;
    }
    return !(this.disableChat || this.selectedChatType.get('disableChat'));
  }

  private async autoAnswerFollowUpIntroMessage(): Promise<void> {
    if (this.selectedChatType?.className !== this.appConfig.Shared.Chat.Type.FOLLOW_UP) return;
    if (this.selectedChatType?.get('count') > 1) return
    if (!this.experimentService.getFollowUpChatDefaultFirstAnswer()) return;
    if (this.autoAnswerTriggered) return;
    this.autoAnswerTriggered = true;

    const latestMessage = this.getLatestMessage(true);
    if (!latestMessage) return;
    if (latestMessage.get('questionId') !== FOLLOW_UP_INTRO_QUESTION) return;
    if (latestMessage.get('Owner') !== this.appConfig.Shared.Assistant.Owner.BOT) return;

    const inputs = latestMessage.get('Inputs');
    if (!inputs?.length) return;

    const treeButtonIndex = inputs.findIndex(
      (input: { action: string; type: string }) => input.action === this.appConfig.Shared.Chat.Inputs.TREE
        && input.type === this.appConfig.Shared.Chat.Inputs.BUTTON
    );
    if (treeButtonIndex < 0) return;

    await this.processAssistantAction(latestMessage, treeButtonIndex);
  }

  processDataAfterFetch(scrollToUnreadMessage?: boolean, restoreScroll?: boolean): void {
    this.zone.run((): void => {
      this.latestMessage = this.getLatestMessage(true);
      this.ui.chatInputEnable = this.enableChatInput();
      this.clearStaleInputIfNoTextStep();
      if (restoreScroll) {
        this.restoreScrollPosition();
      } else {
        this.scrollChatToBottom(scrollToUnreadMessage);
      }
    });
  }

  scrollChatToBottom(scrollToUnreadMessage?: boolean): void {
    setTimeout((): void => {
      if (scrollToUnreadMessage && this.unreadMessageDivider) {
        this.unreadMessageDivider.nativeElement.parentElement.scrollIntoView();
        return;
      }
      const scrollView = this.messageContainer?.nativeElement;
      if (!scrollView) return;

      const jumpToBottom = (): void => {
        this.ui.enableScrollToBottom = false;
        if (scrollView.scroll instanceof Function) {
          scrollView.scroll(0, scrollView.scrollHeight);
        }
        if (scrollView.scrollTop instanceof Function) scrollView.scrollTop = scrollView.scrollHeight;
        const lastVisibleNode = V2ChatComponent.lastVisibleNode(scrollView);
        if ((lastVisibleNode.offsetHeight + lastVisibleNode.offsetTop + this.chatScrollErrorY) > scrollView.offsetHeight) {
          this.chatScrollPossible.emit();
        }
      };

      jumpToBottom();
      Array.from(scrollView.querySelectorAll('img'))
        .filter((img: HTMLImageElement): boolean => !img.complete)
        .forEach((img: HTMLImageElement): void => {
          img.addEventListener('load', jumpToBottom, { once: true });
          img.addEventListener('error', jumpToBottom, { once: true });
        });
    }, 0);
  }

  onMessageLinkClick(event: MouseEvent): void {
    const target = (event.target as HTMLElement).closest('a');
    if (target) {
      const url = target.getAttribute('href');
      if (url) {
        event.preventDefault();
        this.conn.navigateToURL(url);
      }
    }
  }

  onKeyBoardOpen(): void {
    const scrollView = this.messageContainer.nativeElement;
    const scrollToBottom = (): void => {
      if (scrollView.scroll instanceof Function) {
        scrollView.scroll(0, scrollView.scrollHeight);
      }
    };

    // Scroll immediately for instant feedback
    scrollToBottom();

    // Scroll again after keyboard finishes opening (viewport resize settles)
    if (window.visualViewport) {
      let debounceTimer: ReturnType<typeof setTimeout>;
      const onResize = (): void => {
        clearTimeout(debounceTimer);
        debounceTimer = setTimeout((): void => {
          scrollToBottom();
          window.visualViewport!.removeEventListener('resize', onResize);
        }, 150);
      };
      window.visualViewport.addEventListener('resize', onResize);
      // Safety cleanup
      setTimeout((): void => {
        window.visualViewport!.removeEventListener('resize', onResize);
      }, 2000);
    }
  }

  get rebrandedTextInputVisible(): boolean {
    if (!this.latestMessage || this.ui.botReplyInProcess) return false;
    return (this.latestMessage.get('Inputs') || []).some((i: any) => i.type === 'TEXT');
  }

  get rebrandedTextInputPlaceholder(): string {
    const textInput = (this.latestMessage?.get('Inputs') || []).find((i: any) => i.type === 'TEXT');
    return textInput?.text || 'Tell us here';
  }

  sendRebrandedTextInput(): void {
    if (!this.rebrandedTextInputVal?.trim()) return;
    const inputs = this.latestMessage?.get('Inputs') || [];
    const index = inputs.findIndex((i: any) => i.type === 'TEXT');
    if (index < 0) return;
    if (this.rebrandedInputContainsVoice) {
      this.voiceInputService.notifyMessageSentWithVoice(this.rebrandedTextInputVal);
      this.rebrandedInputContainsVoice = false;
    }
    this.dismissVoiceTooltip();
    this.processAssistantAction(this.latestMessage, index, this.rebrandedTextInputVal);
    this.rebrandedTextInputVal = '';
  }

  scrollListener(event: any): void {
    if (this.scrollThrottle) return;
    this.updateOnScroll(event);
    this.scrollThrottle = true;
    setTimeout((): boolean => this.scrollThrottle = false, 200);
  }

  updateOnScroll(event: any): void {
    const containerCords = this.messageContainer.nativeElement.getBoundingClientRect();
    if (event.srcElement.scrollTop < (event.srcElement.offsetHeight * 2)
      && !this.chatPayload.noMoreData
      && !this.chatPayload.loading.old) {
      this.loadOldChat();
    }
    if (event.srcElement.scrollHeight - event.srcElement.scrollTop >= (containerCords.height * 2)) {
      this.ui.enableScrollToBottom = true;
    }
    if ((event.srcElement.scrollTop + containerCords.height + 100) >= event.srcElement.scrollHeight) {
      this.ui.enableScrollToBottom = false;
    }
  }

  recordScrollPosition(): void {
    if (!this.messageContainer) return; // container may not be rendered — see CLAUDE.md gotcha 18
    this.ui.chatScrollTop = this.messageContainer.nativeElement.scrollHeight - this.messageContainer.nativeElement.scrollTop;
  }

  restoreScrollPosition(): void {
    if (!this.ui.chatScrollTop) return;
    setTimeout((): void => {
      if (!this.messageContainer) return;
      this.messageContainer.nativeElement.scrollTop = this.messageContainer.nativeElement.scrollHeight - this.ui.chatScrollTop;
      delete this.ui.chatScrollTop;
    });
  }

  showError(message: any): void {
    this.broadcast.broadcast('NOTIFY', { message: message.error || message.toString() });
  }

  async onUploadReport(event: any): Promise<void> {
    const file = event.target.files[0];
    if (!file) return;
    if (!this.commonUtilityHelper.isFileSizeLesserThanMaxSize(file.size, 5)) {
      this.broadcast.broadcast('NOTIFY', { message: 'File size should be less than 5MB. Kindly retry.' });
      return;
    }
    const response: { publicURL: string; signedGetURL: string } = await this.conn.uploadFile({
      file,
      bucket: 'OTHER',
      username: this.user.get('username'),
      source: 'app_upload_report',
    });
    const userFile = new Table.UserFiles();
    userFile.set('fileUrl', response.publicURL);
    userFile.set('user', this.user);
    userFile.set('type', this.commonUtilityHelper.findFileType(file.name));
    try {
      await userFile.save({}, { context: { supportTicketId: this.selectedChatType.id } });
      await this.loadNewChat();
    } catch (error) {
      this.broadcast.broadcast('NOTIFY', { message: error.toString() });
    }
  }

  async redirectToNewTicket(): Promise<any> {
    const newQuestionId = (this.newHelpTreeExperiment && this.newSupportQuestionId) ? this.newSupportQuestionId : '8L9eKnSUPe';
    if (this.selectedChatType?.className === 'SupportTicket'
    && this.selectedChatType?.get('status') === this.appConfig.Shared.Ticket.status.Completed) {
      const { supportTicketId }: { supportTicketId: string } = await this.conn.createTicket(newQuestionId);
      await this.router.navigate([`/support/ticket/${supportTicketId}`]);
    }
  }

  async processAssistantAction(assistant: any, index?: any, input?: any): Promise<any> {
    if (assistant.get('Inputs') && assistant.get('Inputs').length && index === undefined) {}
    if (!assistant.get('Inputs') || !assistant.get('Inputs').length) return;
    if (this.selectedChatType?.className === 'SupportTicket' && this.route.snapshot.queryParams.reportId) {
      await this.conn.updateFollowUpReportUserFields(this.route.snapshot.queryParams.reportId, { consentFormAsk: false });
    }
    if (assistant.get('Inputs')[index].action === 'ACTION') {
      if (assistant?.get('Inputs')[index]?.params?.queryParams) {
        const params = assistant?.get('Inputs')[index]?.params?.queryParams;
        this.photoType = JSON.parse(params).tag;
        if (this.photoType?.includes(this.appConfig.Shared.InstantCheckup.Type.FACE)) {
          this.localStorageService.setValue('expectedFacePhoto', this.photoType);
        }
      }
      await this.singleSelectorService.openInAppAction(
        assistant.get('Inputs')[index],
        assistant.get('context'),
        this.filePickerComponent,
        assistant.id,
        assistant.className,
        async (inputItem: InputType, data: Record<string, unknown>): Promise<void> => {
          switch (inputItem.params.actionName) {
            case 'OrderSelection': {
              if (data.option) {
                const option = data.option as { orderId: string; orderNumber: string; };
                const context = assistant.get('context');
                context.orderId = option.orderId;
                assistant.set('context', context);
                this.saveUserResponse(assistant, option.orderNumber);
              }
              break;
            }
            case 'MultiProductsSelection': {
              if (data.option) {
                const option = data.option;
                const opts = option as Array<{ title: string; objectId: string }>;
                const titles = opts.map(o => o.title).join(', ');
                const productIds = opts.map(o => o.objectId).join(', ');
                const context = assistant.get('context');
                context.productIds = productIds;
                assistant.set('context', context);
                await this.addProductsToCart(opts);
                this.saveUserResponse(assistant, titles);
              }
              break;
            }
            case 'ProductSelection': {
              if (data.option) {
                const option = data.option as { productId: string; title: string; };
                const context = assistant.get('context');
                context.catalogId = option.productId;
                assistant.set('context', context);
                this.saveUserResponse(assistant, option.title);
              }
              break;
            }
            default:
          }
        });
    } else if (assistant.get('Inputs')[index].action === 'TREE') {
      const message = typeof input === 'string'
        ? input
        : assistant.get('Inputs')[index].text;
      await this.saveUserResponse(assistant, message);
    }
  }

  prepareReply(lastMessage: any, userReply: string): any {
    const reply = new Table[lastMessage?.className](this.where);
    if (lastMessage
      && lastMessage.get('Owner') === this.appConfig.Shared.Assistant.Owner.BOT
      && lastMessage.get('BotMetadata')) {
      reply.set('BotMetadata', `REPLY_${lastMessage.get('BotMetadata')}`);
    }
    let mode = this.appConfig.Shared.Assistant.Mode.TEXT_NOREPLY;
    if (lastMessage && this.responseModes.includes(lastMessage.get('Mode'))) {
      mode = `${lastMessage.get('Mode')}_RESPONSE`;
    }
    if (this.isInternalUser) {
      reply.set('OperatorName', this.currentUser?.get('username'));
    }
    reply.set('user', this.user);
    reply.set('Owner', this.appConfig.Shared.Assistant.Owner.USER);
    reply.set('context', lastMessage.get('context'));
    reply.set('questionId', lastMessage.get('questionId'));
    reply.set('Message', userReply);
    reply.set('Mode', mode);
    reply.set('messageAttendedByBot', lastMessage.get('messageAttendedByBot'));
    reply.set('Owner', this.appConfig.Shared.Assistant.Owner.USER);
    reply.set('UserId', this.user.get('username'));
    reply.set('uniqueId', lastMessage ? `assistant_3_${lastMessage.id}` : uuid());
    return reply;
  }

  async saveUserResponse(prevMessage: any, userReply: string): Promise<any> {
    if (!userReply || this.ui.botReplyInProcess || this.ui.userResponseSaveInProcess) return;
    this.ui.userResponseSaveInProcess = true;
    if (!this.allowAnimation) this.allowAnimation = true;
    if (this.legacyInputContainsVoice) {
      this.voiceInputService.notifyMessageSentWithVoice(userReply);
      this.legacyInputContainsVoice = false;
    }
    // NOTE: do NOT dismiss the tooltip here. saveUserResponse fires for every answer,
    // including button/option (TREE) answers — dismissing here would permanently consume
    // the once-per-session tooltip before a TEXT-input question ever appears. Real input
    // interactions already dismiss it: typing (ngModelChange), voice transcript handlers,
    // tapping the mic (onVoiceStateChange), and the rebranded send (sendRebrandedTextInput).
    const lastMessage = prevMessage || this.getLatestMessage();
    const messageAttendedByBot = lastMessage?.get('messageAttendedByBot');
    const reply = await this.prepareReply(lastMessage, userReply);
    this.addToChats(false, [reply]);
    delete this.chatPayload.input;
    if (messageAttendedByBot) {
      this.updateBotReplyProgress(true);
    }
    this.scrollChatToBottom();
    try {
      await reply.save();
      this.consultationSessionService.triggerAiReportAnalysis(
        this.selectedChatType?.get('PrivateMainConcernClass'), lastMessage?.get('questionId'),
      );
      if (messageAttendedByBot) {
        this.startBotReplyTimer();
      } else {
        setTimeout((): Promise<void> => this.loadNewChat(), 2000);
      }
      this.ui.userResponseSaveInProcess = false;
    } catch (err) {
      this.updateBotReplyProgress(false);
      this.ui.userResponseSaveInProcess = false;
      this.zone.run((): void => this.chats.pop());
      this.showError(err.message || err.toString());
      if (err.code === 412 && err.message.includes('Please answer pending questions.')) {
        await this.loadNewChat();
      } else if (err instanceof Error) {
        this.sentry.handleError(err);
      }
    }
  }

  async armBotReplyPollerIfWaiting(): Promise<void> {
    const latest = this.getLatestMessage(true);
    if (!latest) return;
    if (latest.get('Owner') !== this.appConfig.Shared.Assistant.Owner.USER) return;
    if (!latest.get('messageAttendedByBot')) return;

    if (this.selectedChatType?.className === Table.ConsultationSession.className) {
      const concernClass = this.selectedChatType.get('PrivateMainConcernClass')?.toLowerCase();
      if (concernClass) {
        try {
          await this.conn.switchUserToState(
            `v4_${concernClass}:`,
            { consultationSessionId: this.selectedChatType.id },
          );
        } catch (e) {
          this.sentry.handleError(e);
        }
      }
    }
    await this.startBotReplyTimer();
  }

  cancelBotReplyWaitingTimer(retryFetch?: boolean): void {
    if (!this.ui) return; // destroy can race init — see CLAUDE.md gotcha 18

    this.zone.run((): void => {
      if (this.startTimeOfBotReply && !retryFetch) {
        const time = new Date().getTime() - this.startTimeOfBotReply;
        const lastResponseId = this.getLatestMessage()?.id;
        const lastQuestionId = this.getLatestMessage()?.get('questionId');
        this.eventLogger.trackEvent('BOT_RESPONSE_TIME', { userId: this.user.id, timeInMillSec: time, lastResponseId, lastQuestionId });
        delete this.startTimeOfBotReply;
      }
      if (!retryFetch) {
        this.ui.botReplyTimeSeries = {...this.botReplyTimeSeries};
      }
      this.updateBotReplyProgress(false);
      if (!this.waitForBotReplyTimer) return;
      clearTimeout(this.waitForBotReplyTimer);
      delete this.waitForBotReplyTimer;
    });
  }

  async startBotReplyTimer(log?: boolean): Promise<boolean> {
    return this.zone.run(async (): Promise<boolean> => {
      if (log) {
        this.eventLogger.trackEvent('BOT_RESPONSE_RETRY', {
          userId: this.user.id,
          assistant: this.getLatestMessage(),
        });
      }
      this.cancelBotReplyWaitingTimer(true);
      if (!this.startTimeOfBotReply) {
        this.startTimeOfBotReply = new Date().getTime();
      }
      this.updateBotReplyProgress(true);
      this.chatPayload.loading.new = false;

      const seconds = this.ui.botReplyTimeSeries.t1 + this.ui.botReplyTimeSeries.t2;
      this.waitForBotReplyTimer = setTimeout((): Promise<void> => this.loadNewChat(), seconds);
      this.ui.botReplyTimeSeries.t1 = this.ui.botReplyTimeSeries.t2;
      this.ui.botReplyTimeSeries.t2 = seconds;

      const latestMessage = this.getLatestMessage();
      if (this.isBotReplyDelayed(latestMessage)) return true;
      return false;
    });
  }

  navigateTo(url: string): void {
    if (!url) return;
    let queryString = '';
    if (String(url)
      .toLowerCase()
      .includes('regimen')) {
      queryString += `?class=${this.user.get('PrivateMainConcernClass')}`;
    }
    this.conn.navigateToURL(`${url}${queryString}`);
  }

  /**
   * Calculates the minutes, seconds left and runs the clock timer for every seconds.
   * Opens the regimen once the timer ends and clears the interval.
   * @param {number} milliseconds - no of milliseconds left
   * @param chat
   */
  startRegimenPreparationTimer(milliseconds: number, chat: any): any {
    this.conn.updateExperimentLogsInUser({ regimen_allocation_timer_started: this.user.get('PrivateMainConcernClass') });
    this.eventLogger.trackEvent('regimen_allocation_timer_started', { class: this.user.get('PrivateMainConcernClass') });
    this.zone.run((): void => {
      if (milliseconds <= 0) return;
      const minutes = Math.floor(milliseconds / 1000 / 60);
      this.timer.minutes = (minutes > 2) ? 1 : minutes;
      this.timer.seconds = Math.floor((milliseconds - (minutes * 1000 * 60)) / 1000);
      this.timer.time = chat.get('createdAt');
      this.interval = setInterval(async (): Promise<void> => {
        if (this.timer.seconds - 1 >= 0) this.timer.seconds -= 1;
        if (this.timer.seconds - 1 < 0) {
          this.timer.minutes -= 1;
          this.timer.seconds = 59;
        }
        if (this.timer.minutes < 0) {
          clearInterval(this.interval);
          this.timer = {};
          if (this.unpaidUserDoctorCallExperiment) {
            this.eventLogger.trackEvent('regimen_allocated_request_doctor_call', {class: this.user.get('PrivateMainConcernClass')});
          }
        }
      }, 1000);
    });
    this.localStorageService.delete('sideFaceUploadSkipped');
  }

  isChatVisible(chat: any): boolean {
    return ![this.appConfig.Shared.Assistant.Mode.BLOCK].includes(chat.get('Mode'));
  }

  async openActiveSessionRegimen(fetchRegimen?: boolean): Promise<any> {
    if (fetchRegimen) await this.conn.fetchRegimens(null, true);
    this.scrollChatToBottom();
    this.router.navigate(['/regimen'], {
      queryParams: {
        tab: 'regimen',
        class: this.selectedChatType.get('PrivateMainConcernClass'),
        showTimer: true,
      }
    })
  }


  home(): void {
    const queryParams: any = { tab: 'home' };
    this.router.navigate(['/user'], { queryParams });
  }

  back(): void {
    const moreInsightsBottomsheetShown: boolean = this.localStorageService.getBooleanValue('moreInsightsBottomsheetShown');
    if (this.selectedChatType?.className === 'FollowUp' && !moreInsightsBottomsheetShown && this.fromSelfCheckupBanner) {
      const followupReportGenerating =
        this.followUp?.get('State') === this.appConfig.Shared.Followup.State.PENDING && this.followUp?.get('ready');
      if (followupReportGenerating && !this.followUpChatCompleted) {
        const sheetRef: MatBottomSheetRef<MoreInsightsBottomsheetComponent> = this.bottomSheet.open(MoreInsightsBottomsheetComponent);
        sheetRef.backdropClick().pipe(take(1)).subscribe(() => sheetRef.dismiss());
        return;
      }
    }
    this.localStorageService.delete('moreInsightsBottomsheetShown');
    if (this.selectedChatType.className === 'SupportTicket') {
      const queryParams: any = { returnedFrom: 'supportTicket' };
      this.router.navigate(['/support'], { queryParams });
      return;
    }
    if (this.selectedChatType.className === 'ConsultationSession') {
      const sheetRef = this.consultationSessionService.validateAndOpenSkipConsultationQuestionsSheet(
        this.userFirstName,
        this.chatSkipLastQuestionsExperiment,
        this.selectedChatType,
      );
      if (sheetRef) {
        return;
      }
    }
    const queryParams: any = { tab: 'home' };
    this.router.navigate(['/user'], { queryParams });
    this.eventLogger.cleverTapEvent('clickedBack', JSON.stringify({ name: 'home' }), [
      this.appConfig.Shared.EventTracker.CLEVER_TAP,
      this.appConfig.Shared.EventTracker.MOENGAGE,
      this.appConfig.Shared.EventTracker.CURESKIN_METRICS,
    ]);
  }

  handleBackPress(): boolean {
    this.back();
    return true;
  }

  /**
   * Logs the last visited time of that ticket in the ticket table.
   */
  ngOnDestroy(): void {
    if (!this.isInternalUser && this.selectedChatType?.className === 'SupportTicket') {
      this.conn.updateUserLastActiveDetails(this.selectedChatType.id);
    }
    this.currentComponent.remove(this);
    this.chatProgressService.chatLoading.set(false);
    this.cancelBotReplyWaitingTimer();
    clearInterval(this.interval);
    this.subscriptions.forEach((subscription: Subscription): void => subscription.unsubscribe());
    this.subscriptions = [];
  }

  private static lastVisibleNode(nativeElement: any): any {
    let index = nativeElement.childNodes.length - 1;
    while (index > 0) {
      if (nativeElement.childNodes[index].nodeName === 'DIV') {
        break;
      }
      index -= 1;
    }
    return nativeElement.childNodes[index];
  }

  async updateFeedback(isHelpfull: boolean, userQuery?: string): Promise<void> {
    if (!isHelpfull) {
      this.eventLogger.trackEvent('support-ticket-dislike');
      this.eventLogger.cleverTapEvent('click', JSON.stringify({ name: 'support-ticket-dislike' }));
    } else {
      this.eventLogger.trackEvent('support-ticket-like');
      this.eventLogger.cleverTapEvent('click', JSON.stringify({ name: 'support-ticket-like' }));
    }
    if (this.isInternalUser) return;
    this.isHelpfull = isHelpfull;
    const result = await this.conn.updateSupportTicketFeedback(this.selectedChatType.id, isHelpfull, userQuery, true);
    if (result.ticketStatusChanged) {
      this.selectedChatType = await this.conn.findSupportTicketById(this.route.snapshot.params.id, { translate: true });
      if (this.selectedChatType?.get('status') === this.appConfig.Shared.Ticket.status.Pending) await this.loadNewChat();
      return;
    }
    this.afterSaveFeedback = true;
  }

  updateFeedBackIfFalse(): any {
    this.eventLogger.trackEvent('support-ticket-dislike');
    this.eventLogger.cleverTapEvent('click', JSON.stringify({ name: 'support-ticket-dislike' }));
    this.bottomSheet.open(GetFeedbackSheetComponent, {
      data: {
        updateFeedbackAndCreatePendingCall: async (createCall: boolean, userQuery?: string): Promise<void> => {
          if (createCall) {
            await this.updateFeedbackAndCreatePendingCall(this.isHelpfull, userQuery);
            this.bottomSheet.dismiss();
          } else {
            await this.updateFeedback(this.isHelpfull, userQuery);
            this.bottomSheet.dismiss();
          }
        },
      },
    });
  }

  async updateFeedbackAndCreatePendingCall(isHelpfull: boolean, userQuery?: string): Promise<void> {
    if (this.isInternalUser) return;
    this.isHelpfull = isHelpfull;
    const result = await this.conn.createPendingCallAndSaveNote({ message: userQuery,
      type: ApiClientConstant.PendingCall.Type.UserRequestedCall,
      ticketId: this.selectedChatType?.id,
      user: this.user });
    await this.conn.updateSupportTicketFeedback(this.selectedChatType.id, false, userQuery, false);
    if (result.message === 'success') {
      this.selectedChatType = await this.conn.findSupportTicketById(this.route.snapshot.params.id, { translate: true });
      if (this.selectedChatType?.get('status') === this.appConfig.Shared.Ticket.status.Pending) await this.loadNewChat();
      return;
    }
    this.bottomSheet.dismiss();
    this.afterSaveFeedback = true;
  }

  async openImageFromBothSidePhotos({ imageUrl, chat }: { imageUrl: string; chat: ChatMessageData }): Promise<boolean | void> {
    const instantCheckup = await this.conn.fetchInstantCheckupByImageUrl(this.conn.getActingUser(), imageUrl);
    const checkupId = instantCheckup?.id;
    if (!instantCheckup || !checkupId) return
    const { CONSULTATION_SESSION_CHAT, FOLLOW_UP_CHAT } = this.appConfig.Shared.CLASSNAME;
    const queryParams = [CONSULTATION_SESSION_CHAT, FOLLOW_UP_CHAT].includes(chat?.className)
      ? { ...chat?.get('context') }
      : {};
    return this.router.navigate([`/user/instantCheckup/${checkupId}`], { queryParams });
  }

  getExpectedPhotoType(chat: any): string {
    if (chat?.get('questionId') === 'TakeInstantCheckup') {
      return this.appConfig.Shared.InstantCheckup.Type.FRONT_FACE;
    }
    if (chat?.get('questionId') === 'TakeInstantCheckSideFace') {
      return this.appConfig.Shared.InstantCheckup.Type.SIDE_FACE;
    }
    if (chat?.get('questionId') === 'HairfallPhoto') {
      return this.appConfig.Shared.InstantCheckup.Type.HAIR_FRONT;
    }
    if (chat?.get('questionId') === 'HairfallPhotoTop') {
      return this.appConfig.Shared.InstantCheckup.Type.HAIR_TOP;
    }
    return this.appConfig.Shared.InstantCheckup.Type.FACE;
  }

  handleImageCardClick(chat: any):void {
    const expectedPhotoType = this.getExpectedPhotoType(chat);
    if (expectedPhotoType.includes(this.appConfig.Shared.InstantCheckup.Type.FACE) || expectedPhotoType.includes(this.appConfig.Shared.InstantCheckup.Type.HAIR)) {
      this.localStorageService.setValue('expectedFacePhoto', expectedPhotoType);
    }
    this.localStorageService.delete('fromSelfCheckupBanner');
    this.setRedirectUrl();
  }

  setRedirectUrl(): void {
    this.navigationService.persistRedirectUrl();
  }

  updateBotReplyProgress(isBotReplyInPorcess: boolean): void {
    this.ui.botReplyInProcess = isBotReplyInPorcess;
    this.botReplyInProcessChange.emit(isBotReplyInPorcess);
  }


  get progress(): number {
    return this.chatProgressService.getChatProgressState().value;
  }

  /** Whether to render the consultation chat progress bar (avoids a raw class-name string in the template). */
  get showConsultationProgressBar(): boolean {
    return !this.hideNavBar
      && this.selectedChatType?.className === Table.ConsultationSession.className
      && this.isNotIOSDevice;
  }

  get isRegimenExpired(): boolean {
    return this.regimenExpiryService.shouldShowRegimenExpiredBanner({
      regimens: [],
      totalAmountSpent: this.user.get('totalAmountSpent'),
      isPaidUser: this.isPaidUser,
      consultationSession: undefined,
      skipHide: true
    });
  }

  convertTextToHtml(text: string): string {
    return this.commonUtilityHelper.convertTextToHtml(text);
  }

  formatTime(dateString: string): string {
    return this.timeService.formatChatTime(dateString);
  }

  shouldRenderActionCta(chat: any): boolean {
    return !isPhotoQuestion(chat, this.selectedChatType?.className) || chat === this.latestMessage;
  }


  private async addProductsToCart(
    products: Array<{ title: string; objectId: string }>
  ): Promise<void> {
    for (const product of products) {
      const params = {
        productId: product.objectId,
        quantity: 1,
        section: 'reOrderTree',
      };

      await this.conn.addProductToNewCart(params);
    }
  }

  private updateChatLoading(isLoading: boolean): void {
    this.chatProgressService.chatLoading.set(isLoading);
    this.chatLoadingStatus.emit(isLoading);
  }
}
